import {
    ModalContent,
    ModalFooter,
    ModalHeader,
} from './ModalView'
import Modal from './Modal'

export {
    ModalHeader,
    ModalFooter,
    ModalContent,
    Modal,
}
